var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagMony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 7.33464V6.66797",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 11.332V11.9987",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84266 10.856C7.01532 11.1387 7.30999 11.334 7.66666 11.334H7.99999H8.39732C8.91466 11.334 9.33332 10.9147 9.33332 10.398C9.33332 9.9687 9.04066 9.5947 8.62466 9.48936L7.37466 9.17536C6.95932 9.07136 6.66666 8.69736 6.66666 8.26803C6.66666 7.7507 7.08599 7.33203 7.60266 7.33203H7.99999H8.33332C8.68866 7.33203 8.98332 7.5267 9.15532 7.8087",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 13.6667H3.33333C2.59667 13.6667 2 13.07 2 12.3333V6.33333C2 5.59667 2.59667 5 3.33333 5H12.6667C13.4033 5 14 5.59667 14 6.33333V12.3333C14 13.07 13.4033 13.6667 12.6667 13.6667Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7828 4.9987V3.66536C10.7828 2.9287 10.1861 2.33203 9.44944 2.33203H6.55077C5.8141 2.33203 5.21744 2.9287 5.21744 3.66536V4.9987",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagMony);
export default __webpack_public_path__ + "static/media/bag-mony.66248b6b6d3ea0e4d6c43e12530e8d0b.svg";
export { ForwardRef as ReactComponent };